const isModalOpen = state => state.isModalOpen

export default {
  isModalOpen
}
